import Component from 'flarum/common/Component';
export default class SlideTabVertical extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.callback = this.attrs.callback;
    this.tabList = this.attrs.tabList;
    this.style = this.attrs.style;
    this.selectedSetting = null;
  }
  oncreate() {
    this.checkHashTag();
  }
  checkHashTag() {
    const dom = $(".zivenSlideVericalTabMenu");
    if (dom.length === 0) {
      return;
    }
    let selectedSetting = this.selectedSetting;
    let urlHash = window.location.hash.substring(1);
    for (let i = 0; i < this.tabList.length; i++) {
      if (this.tabList[i].key === urlHash) {
        this.selectedSetting = urlHash;
        break;
      }
    }
    if (this.selectedSetting === null && this.tabList.length > 0) {
      this.selectedSetting = this.tabList[0].key;
    }
    if (typeof this.callback === "function" && this.selectedSetting !== null) {
      this.callback(this.selectedSetting);
      if (selectedSetting !== this.selectedSetting) {
        m.redraw();
      }
    }
  }
  view() {
    let count = 0;
    this.checkHashTag();
    return m("div", {
      style: this.style,
      className: "zivenSlideVericalTabMenu"
    }, this.tabList.map(tabData => {
      const tabName = app.translator.trans(tabData.name);
      const tabEvent = tabData.event;
      const tabKey = tabData.key;
      count++;
      let className = "zivenSlideVericalTabToggle";
      if (this.selectedSetting === null) {
        if (count === 1) {
          className += " zivenSlideVericalTabSelected";
        }
      } else {
        if (this.selectedSetting === tabKey) {
          className += " zivenSlideVericalTabSelected";
        }
      }
      return m("div", {
        id: "zivenSlideVerticalTab-item-" + count,
        tabKey: tabKey,
        count: count,
        className: className,
        onclick: e => {
          $(".zivenSlideVericalTabToggle").removeClass("zivenSlideVericalTabSelected");
          $(e.target).addClass("zivenSlideVericalTabSelected");
          tabEvent(e, tabKey);
          window.location.hash = tabKey;
          history.replaceState(undefined, undefined, "#" + tabKey);
        }
      }, tabName);
    }));
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/components/SlideTabVertical', SlideTabVertical);